import styled from 'styled-components';

export const TwoColContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/container/TwoColContent.js